import { ReactNode, useEffect } from 'react';

import useCookieStore from '../../store/cookieStore/useCookieStore';

const CookieConsentGuard = ({
  children,
}: {
  children: ReactNode;
}): ReactNode => {
  const { loadConsentManager } = useCookieStore();

  useEffect((): void => {
    loadConsentManager();
  }, [loadConsentManager]);

  return children;
};

export default CookieConsentGuard;
